import React from 'react'
import Isvg from 'react-inlinesvg'
import { Link } from 'react-router-dom'
import './PreHome.scss'

const PreHomeCard = ({icon, text, url}) => (
    <Link to={url} className="pre-home-card">
        <div className="icon-container">
            <Isvg src={icon} />
        </div>
        <p className="text">{text}</p>
    </Link>
);

export default PreHomeCard


// WEBPACK FOOTER //
// ./src/components/Card/PreHome.js